// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_DELETE_REVIEW = "Zma\u017e hodnotenie";
export const BZ2_DELETE_REVIEW_REPLY = "Zma\u017e odpove\u010f";
export const BZ2_REPLY_THE_REVIEW = "Odpovedz";
